var map = {
	"./Checkout": [
		2391,
		391
	],
	"./Checkout/": [
		2391,
		391
	],
	"./Checkout/index": [
		2391,
		391
	],
	"./Checkout/index.tsx": [
		2391,
		391
	],
	"./ContactUs": [
		3706,
		706
	],
	"./ContactUs/": [
		3706,
		706
	],
	"./ContactUs/index": [
		3706,
		706
	],
	"./ContactUs/index.tsx": [
		3706,
		706
	],
	"./CookiesPolicy": [
		1837,
		837
	],
	"./CookiesPolicy/": [
		1837,
		837
	],
	"./CookiesPolicy/index": [
		1837,
		837
	],
	"./CookiesPolicy/index.tsx": [
		1837,
		837
	],
	"./Home": [
		1145,
		145
	],
	"./Home/": [
		1145,
		145
	],
	"./Home/index": [
		1145,
		145
	],
	"./Home/index.tsx": [
		1145,
		145
	],
	"./Menu": [
		4453,
		112,
		453
	],
	"./Menu/": [
		4453,
		112,
		453
	],
	"./Menu/index": [
		4453,
		112,
		453
	],
	"./Menu/index.tsx": [
		4453,
		112,
		453
	],
	"./OrderDetail": [
		7219,
		51,
		219
	],
	"./OrderDetail/": [
		7219,
		51,
		219
	],
	"./OrderDetail/index": [
		7219,
		51,
		219
	],
	"./OrderDetail/index.tsx": [
		7219,
		51,
		219
	],
	"./OrderFail": [
		4058,
		58
	],
	"./OrderFail/": [
		4058,
		58
	],
	"./OrderFail/index": [
		4058,
		58
	],
	"./OrderFail/index.tsx": [
		4058,
		58
	],
	"./OrderSuccess": [
		2435,
		435
	],
	"./OrderSuccess/": [
		2435,
		435
	],
	"./OrderSuccess/index": [
		2435,
		435
	],
	"./OrderSuccess/index.tsx": [
		2435,
		435
	],
	"./OrderSummary": [
		4927,
		988,
		927
	],
	"./OrderSummary/": [
		4927,
		988,
		927
	],
	"./OrderSummary/index": [
		4927,
		988,
		927
	],
	"./OrderSummary/index.tsx": [
		4927,
		988,
		927
	],
	"./Orders": [
		5853,
		853
	],
	"./Orders/": [
		5853,
		853
	],
	"./Orders/index": [
		5853,
		853
	],
	"./Orders/index.tsx": [
		5853,
		853
	],
	"./PrivacyPolicy": [
		4444,
		444
	],
	"./PrivacyPolicy/": [
		4444,
		444
	],
	"./PrivacyPolicy/index": [
		4444,
		444
	],
	"./PrivacyPolicy/index.tsx": [
		4444,
		444
	],
	"./Profile": [
		4805,
		725,
		179
	],
	"./Profile/": [
		4805,
		725,
		179
	],
	"./Profile/index": [
		4805,
		725,
		179
	],
	"./Profile/index.tsx": [
		4805,
		725,
		179
	],
	"./Restaurant": [
		2840,
		1
	],
	"./Restaurant/": [
		2840,
		1
	],
	"./Restaurant/index": [
		2840,
		1
	],
	"./Restaurant/index.tsx": [
		2840,
		1
	],
	"./Review": [
		1432,
		432
	],
	"./Review/": [
		1432,
		432
	],
	"./Review/index": [
		1432,
		432
	],
	"./Review/index.tsx": [
		1432,
		432
	],
	"./Terms": [
		59,
		59
	],
	"./Terms/": [
		59,
		59
	],
	"./Terms/index": [
		59,
		59
	],
	"./Terms/index.tsx": [
		59,
		59
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;